"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LabelGroup_1 = require("./LabelGroup");
exports.default = LabelGroup_1.default;
//# sourceMappingURL=index.js.map